import idb from "@/plugins/indexdb.js";
import ColorsRepository from "../../repositories/colorsRepository";
import { get } from "core-js/core/dict";

export default {
  namespaced: true,
  state: {
    colors: []
  },
  mutations: {
    // Set colors
    SET_COLORS(state, colors) {
      state.colors = colors;
    }
  },
  actions: {
    // Get all colors from api
    async fetchColors() {
      try {
        const { data } = await ColorsRepository.fetchColors();

        // Delete all entries
        await idb.db.colors.clear();

        // Save in IndexedDB
        await idb.db.colors.bulkAdd(data);
      } catch (error) {
        console.log(error);
      }
    },

    // Gets all colors from IndexedDB
    async getAllColors({ commit }) {
      try {
        const colors = await idb.db.colors.toArray();
        commit("SET_COLORS", colors);
        return;
      } catch (error) {
        throw error;
      }
    },

    // Gets colors by type
    async getColorsByType(context, color_type) {
      try {
        return await idb.db.colors.where({ type: color_type }).toArray();
      } catch (error) {
        throw error;
      }
    },

    // Gets the transfer type colors in IndexedDB
    async getTransferType() {
      try {
        return await idb.db.colors.where({ type: "TRANSFER" }).toArray();
      } catch (error) {
        throw error;
      }
    },

    // Gets the xxl type colors in IndexedDB
    async getXXLType() {
      try {
        return await idb.db.colors.where({ type: "XXL" }).toArray();
      } catch (error) {
        throw error;
      }
    },

    // Gets the light type colors in IndexedDB
    async getLightType() {
      try {
        return await idb.db.colors.where({ type: "LIGHT" }).toArray();
      } catch (error) {
        throw error;
      }
    },

    // Gets the plama type colors in IndexedDB
    async getPalmaType() {
      try {
        return await idb.db.colors.where({ type: "PALMA" }).toArray();
      } catch (error) {
        throw error;
      }
    },

    // Gets the seat type colors in IndexedDB
    async getSeatType() {
      try {
        return await idb.db.colors.where({ type: "SEAT" }).toArray();
      } catch (error) {
        throw error;
      }
    },

    // Clean store
    async clean({ commit }) {
      commit("setColors", []);
      return;
    }
  },
  getters: {

    // colorsByType: (state) => (type) => {
    //   return state.colors.filter(color => color.type === type);
    // },

    colorsByType: (state) => {
      return state.colors.reduce((groups, color) => {
        const type = color.type;
        if (!groups[type]) {
          groups[type] = [];
        }
        groups[type].push(color);
        return groups;
      }, {});
    },

    getColorsByType: (state, getters) => (type) => {
      return getters.colorsByType[type] || [];
    },

    getColorById: (state) => (id) => {
      return state.colors.find(color => color.id === id);
    },

    colorsType: state => [...new Set(state.colors.map(color => color.type))],

    getXXLType: state => {
      return state.colors
        .filter(color => color.type === "XXL")
        .sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0));
    },

    getLIGHTType: state => {
      return state.colors
        .filter(color => color.type === "LIGHT")
        .sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0));
    },

    getTRANSFERType: state => {
      return state.colors
        .filter(color => color.type === "TRANSFER")
        .sort((a, b) =>
          a.label.toLowerCase() < b.label.toLowerCase()
            ? -1
            : a.label.toLowerCase() > b.label.toLowerCase()
              ? 1
              : 0
        );
    },

    getPALMAType: state => {
      return state.colors
        .filter(color => color.type === "PALMA")
        .sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0));
    },

    getSEATType: state => {
      return state.colors
        .filter(color => color.type === "SEAT")
        .sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0));
    },

    get3DType: state => {
      return state.colors
        .filter(color => color.type === "3D")
        .sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0));
    },

    getTHERMOType: state => {
      return state.colors
        .filter(color => color.type === "THERMO")
        .sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0));
    },

    getPLASTAType: state => {
      return state.colors
        .filter(color => color.type === "PLASTAZOTE")
        .sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0));
    },

    getEVAZOTEType: state => {
      return state.colors
        .filter(color => color.type === "EVAZOTE")
        .sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0));
    },

    getSKAIType: state => {
      return state.colors
        .filter(color => color.type === "SKAI")
        .sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0));
    },

    getSTRETCHType: state => {
      return state.colors
        .filter(color => color.type === "STRETCH")
        .sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0));
    },

    getALCANTARAType: state => {
      return state.colors
        .filter(color => color.type === "ALCANTARA")
        .sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0));
    },

    getBASESType: state => {
      return state.colors
        .filter(color => color.type === "BASES")
        .sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0));
    },

    getLIFTType: state => {
      return state.colors
        .filter(color => color.type === "LIFT")
        .sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0));
    }
  }
};
